import { Component, Input } from "@angular/core";
import { QuestionDate } from "src/app/main/model/forms/question-date.model";
import { FormCompletionBaseComponent } from "../form-completion-base.component";

@Component({
  selector: "app-question-date",
  templateUrl: "./question-date.component.html",
  styleUrls: ["./question-date.component.scss"],
  standalone: false,
})
export class QuestionDateComponent extends FormCompletionBaseComponent {
  @Input() public question: QuestionDate;
}
